import script from "./programmlist.vue?vue&type=script&setup=true&lang=js"
export * from "./programmlist.vue?vue&type=script&setup=true&lang=js"

import "./programmlist.vue?vue&type=style&index=0&id=098991bf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098991bf"]])

export default __exports__